import { Button } from "reactstrap";
import { ActionTypeEnum } from "../../enums";
import { useTranslation } from "react-i18next";

type TProps = {
  actionType: ActionTypeEnum;
  state?: boolean;
  onAction: () => void;
  title?: string;
  color?: string;
};
export const ActionButton: React.FC<TProps> = ({
  actionType,
  onAction,
  state = false,
  color,
}) => {
  const { t } = useTranslation();

  if (actionType === ActionTypeEnum.EDIT)
    return (
      <Button
        color={color || "primary"}
        className="btn-sm"
        onClick={onAction}
        title={t("edit")}
      >
        {t("edit")}
      </Button>
    );

  if (actionType === ActionTypeEnum.DELETE)
    return (
      <Button
        color={color || "danger"}
        className="btn-sm"
        onClick={onAction}
        title={t("delete")}
      >
        {t("delete")}
      </Button>
    );

  if (actionType === ActionTypeEnum.BLOCK) {
    if (state === true) {
      return (
        <Button
          color={color || "primary"}
          className="btn-sm"
          onClick={onAction}
          title={t("unblock")}
        >
          {t("unblock")}
        </Button>
      );
    } else if (state === false) {
      return (
        <Button
          color={color || "danger"}
          className="btn-sm"
          onClick={onAction}
          title={t("block")}
        >
          {t("block")}
        </Button>
      );
    }
  }
  if (actionType === ActionTypeEnum.ACTIVE_INACTIVE) {
    if (state === true) {
      return (
        <Button
          color={color || "primary"}
          className="btn-sm"
          onClick={onAction}
          title={t("deactivate")}
        >
          {t("deactivate")}
        </Button>
      );
    } else if (state === false) {
      return (
        <Button
          color={color || "danger"}
          className="btn-sm"
          onClick={onAction}
          title={t("activate")}
        >
          {t("activate")}
        </Button>
      );
    }
  }
  if (actionType === ActionTypeEnum.PHONE_VERIFY) {
    if (state === true) {
      return (
        <Button
          color={color || "primary"}
          className="btn-sm"
          onClick={onAction}
          title={t("markUnverified")}
        >
          {t("markUnverified")}
        </Button>
      );
    } else if (state === false) {
      return (
        <Button
          color={color || "danger"}
          className="btn-sm"
          onClick={onAction}
          title={t("markVerified")}
        >
          {t("markVerified")}
        </Button>
      );
    }
  }
};
